// extracted by mini-css-extract-plugin
export default {"container":"artist-block_container_pg2Q5","inner":"artist-block_inner_ux1Jk"};